import { useLogrocket } from 'hooks/useLogrocket';

export const Tracking = () => {
  useLogrocket();
  return <></>;
};
